globalThis.Chat = class Chat {
  constructor() {
    globalThis.CHAT = this;
    this.div = document.createElement("div");
    this.div.id = "chat";
    document.body.append(this.div);
  }

  remove() {
    this.div.remove();
    delete globalThis.CHAT;
  }

  push(msg, options = {}) {
    const div = document.createElement("div");
    div.innerText = msg;
    div.className = options.type || "";
    this.div.append(div);
  }
};
